/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function (Module, $, SCS) {
	'use strict';

	function isTrackingReady() {
		return SCS.tealium && SCS.tealium.isReady() &&
			SCS.datalayer.getAnalyticsPageName &&
			SCS.datalayer.getAnalyticsPageName();
	}

	/**
	 * Yet Another Tab Component.
	 * Supports deeplinking via #<tabId>=<tabNo> or custom hash parameter per tab (useful for integrating Angular apps).
	 *
	 * @author Ces
	 * @namespace Tc.Module
	 * @class SDXTabs
	 * @extends Tc.Module
	 */
	Module.SDXTabs = Module.extend({

		init: function ($ctx) {
			var mod = this;

			mod.sdxTabs = $ctx[0];
			mod.tabId = $ctx.data('tab-id') || 'tab';
			mod.$tabs = $ctx.find('.tab-link');
			mod.itemSelector = 'sdx-tabs-item, sdx-select-option';
			mod.retryTimeout = 5000;

			// caching panels
			mod.$panels = mod.$tabs.map(function() {
				if (this.dataset.panel) {
					return $('.' + this.dataset.panel);
				}
				return $();
			});

			mod.log('init', mod.tabId, mod.$tabs.length);
		},

		on: function (callback) {
			var mod = this;

			mod.log('on', mod.tabId, mod.$tabs.length);
			mod.deepLinking();
			mod.addEvents();

			mod.executeInitialTracking(function () {
				mod.$tabs.each(function (idx, item) {
					var $tab = $(item);
					if ($tab.find(mod.itemSelector).prop('selected') || $tab.hasClass('active')) {
						var trackLabel = $tab.data('track-label'),
							trackCategory = $tab.data('track-category');
						SCS.portal.datalayer.trackEvent('view', trackLabel, SCS.datalayer.getAnalyticsPageName(), trackCategory);
						mod.log('executeInitialTracking', mod.tabId, trackLabel, trackCategory);
						return false;
					}
				});
			});

			callback();
		},

		/**
		 * Preselect a tab based on hash parameters.
		 */
		deepLinking: function () {
			var mod = this,
				hashValue = SCS.HashDeepLink.get(mod.tabId);

			var selectedTabIndex = mod.$tabs.get().findIndex(function(item) { return item.dataset.panel === hashValue; });
			if(selectedTabIndex === -1) {
				// Fallback to old functionality where tab index number is used as hash value
				selectedTabIndex = parseInt(hashValue, 10);
			}
			if (selectedTabIndex >= 0) {
				mod.log('deepLinking - found matching tabId hash', location.hash, mod.tabId, selectedTabIndex);

			} else if (location.hash) {
				mod.$tabs.each(function (index) {
					var hash = $(this).data('hash');
					if (hash === location.hash) {
						selectedTabIndex = index;
						mod.log('deepLinking - found matching custom hash', location.hash, mod.tabId, selectedTabIndex);
						return false;
					}
				});
			}
			mod.$tabs.eq(selectedTabIndex || 0).find(mod.itemSelector).prop('selected', true);
			mod.switchToPanel(selectedTabIndex);

			mod.log('deepLinking', mod.tabId, selectedTabIndex);
			return selectedTabIndex;
		},

		/**
		 * Attach change event on tabs, and handle hashchange event.
		 */
		addEvents: function () {
			var mod = this;

			mod.sdxTabs.changeCallback = mod.handleSdxTabsChange.bind(mod);
			mod.sdxTabs.selectCallback = mod.handleSdxTabsChange.bind(mod);
			window.addEventListener('hashchange', mod.deepLinking.bind(mod));
		},

		/**
		 * Handle tab switch
		 *
		 * @param {HTMLElement | String} tab - the now active sdx-tabs-item | the value (index) of the selected sdx-select-option
		 */
		handleSdxTabsChange: function (tab) {
			var mod = this,
				$tab;

			if (/sdx-tabs-item/i.test(tab.nodeName)) {
				$tab = $(tab).closest('.tab-link');
			} else {
				// sdx-select-option
				$tab = mod.$tabs.eq(tab);
			}

			var activePanel = $tab.data('panel'),
				selectedTabIndex = mod.$tabs.index($tab),
				hash = $tab.data('hash');

			if (hash) {
				location.hash = hash;
			} else {
				SCS.HashDeepLink.set(mod.tabId, activePanel || selectedTabIndex, '&');
			}

			mod.switchToPanel(selectedTabIndex);

			var trackLabel = $tab.data('track-label'),
				trackCategory = $tab.data('track-category');

			SCS.portal.datalayer.trackEvent('view', trackLabel, SCS.datalayer.getAnalyticsPageName(), trackCategory);

			mod.log('handleSdxTabsChange', mod.tabId, selectedTabIndex, activePanel, hash);
		},

		/**
		 * Show the panel of the selected tab, and hide the others.
		 *
		 * @param {number} selectedTabIndex - the tab of which the panel should be shown
		 */
		switchToPanel: function (selectedTabIndex) {
			var mod = this,
				i = selectedTabIndex < mod.$tabs.length ? selectedTabIndex : 0;

			if ($(document.body).hasClass('cq_isEditMode')) {
				return;
			}

			mod.$panels.each(function(index) {
				$(this).toggleClass('hideSDXTab', index !== i);
			});

			$(window).trigger('resize'); // force jQuery Lazy to re-check which images are now visible
		},

		// check if tracking is ready and process queued events
		executeInitialTracking: function (callback) {
			var mod = this;

			clearTimeout(this.timeout); // if undefined silently does nothing

			if (isTrackingReady()) {
				callback();
				return;
			}

			if (mod.retryTimeout > 0) {
				this.timeout = setTimeout(function () {
					mod.retryTimeout -= 80;
					mod.executeInitialTracking(callback);
				}, 80);
			}
		}
	});
}(window.Tc.Module, window.Tc.$, window.SCS = window.SCS || {}));

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/sdx_expand/js/modules/Tc.Module.SDXTabs.js
// module id = 370
// module chunks = 0